import classnames from 'classnames';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';

import { withI18n, WithI18nProps } from '../../../../internationalization/i18n-hoc';
import { PlotKeyToggleState } from '../../../../stores/plot-key-toggle-state';
import { RoleBuilderCompetencyBars } from '../role-builder-competency-bars/role-builder-competency-bars';
import { RoleBuilderHelper } from '../../../stores';
import { RoleBuilderCompetencyRadar } from '../role-builder-competency-radar/role-builder-competency-radar';
// import { PlotKeyLegend } from "../../components/plot-key-legend/plot-key-legend"

const styles = require('../../../../ui/screens/quiz-summary/quiz-summary.css');

interface RoleBuilderSummaryProps extends WithI18nProps {
  rb: RoleBuilderHelper;
  plotKeyToggleState: PlotKeyToggleState;
}

// export interface LoadedProps {
//   /** Data response object with all quiz results and the skills competencies model */
//   quizResults: SingleUserQuizResults
//   userQuizTrainingOfferings: SingleUserTrainingRecommendations
// }

@observer
class RoleBuilderSummary0 extends React.Component<RoleBuilderSummaryProps> {
  @observable
  selectedCompetency: string | undefined = undefined;
  @observable
  lastSelectedCompetency: string | undefined = undefined;

  @action
  selectCompetency = (selected: string): void => {
    this.selectedCompetency = this.selectedCompetency === selected ? undefined : selected;
    if (this.selectedCompetency !== undefined) {
      this.lastSelectedCompetency = this.selectedCompetency;
    }
  };

  renderSlidingContent(rb: RoleBuilderHelper): JSX.Element {
    /// Display headline explanatory text: only if
    /// - prop is not undefined and set to TRUE
    /// - displayHeadlineRatio is OFF
    /// - role comparisons are not active
    // TODO: restore when multiple roles are available
    // const roleComparisonsActive = rb.getSelectedRoleIds().length > 0

    const radarStyle = styles.radarContainer2;

    return (
      // TODO: CSS & relative sizing
      // <div className={styles.content} style={{height: 500}}>
      <div className={styles.content}>
        <div className={this.slideIf(this.selectedCompetency === undefined, radarStyle)}>
          <RoleBuilderCompetencyRadar
            helper={rb}
            gridRadii={rb.setRadii()}
            plotKeyToggleState={this.props.plotKeyToggleState}
            onCompetencyClick={this.selectCompetency}
            selectedCompetency={this.selectedCompetency}
            // viewBox={{width: 500, height: 500}}
          />
        </div>
        <div className={this.slideIf(this.selectedCompetency === undefined, styles.barContainer)}>
          {this.lastSelectedCompetency !== undefined && (
            <RoleBuilderCompetencyBars
              competencyId={this.lastSelectedCompetency}
              plotKeyToggleState={this.props.plotKeyToggleState}
              helper={rb}
            />
          )}
        </div>
      </div>
    );
  }

  slideIf(condition: boolean, className: string) {
    if (!condition) {
      return classnames(className, styles.animate, styles.toSlide);
    } else {
      return classnames(className, styles.animate);
    }
  }

  render() {
    const { rb } = this.props;
    // TODO: Don't need legend really until we mix multiple roles, or display industry. At which point we have
    // to do more work to incorporate RoleBuilderHelper. But 'plotKeyToggleState' is managed in the Legend component
    return (
      <div className={styles.report}>
        {/* <div className={styles.legendContainer}>
          <PlotKeyLegend
            qr={qr}
            plotKeyToggleState={this.props.plotKeyToggleState} 
            displayHeadlineRatio={false}
            displayHeadlineText={false}
          />
        </div> */}
        {this.renderSlidingContent(rb)}
      </div>
    );
  }
}

export const RoleBuilderSummary = withI18n(RoleBuilderSummary0);



// WEBPACK FOOTER //
// ./src/admin/ui/components/detail-views/role-builder-summary-view.tsx